import type { PostHogConfig } from 'posthog-js'

export const postHogConfig: { api_key: string | undefined; options: Partial<PostHogConfig> } = {
	api_key: import.meta.env.VITE_POSTHOG_API_KEY,
	options: {
		debug: import.meta.env.VITE_APP_ENV === 'development',
		api_host: import.meta.env.VITE_POSTHOG_HOST || 'https://b.jobilla.com',
		ui_host: import.meta.env.VITE_POSTHOG_UI_HOST || 'https://eu.posthog.com',
		person_profiles: 'identified_only',
		persistence: 'localStorage+cookie',
		autocapture: false,
		capture_pageview: true,
		capture_pageleave: true,
	},
}
